import { Outlet, useParams, useLocation } from "react-router-dom";
import Header from "../../layouts/header/Header";
import Footer from "../../layouts/footer/Footer";
import ScrollToTop from "../common/scroll-to-top/ScrollToTop";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LanguageProvider } from "../../context/LanguageContext";
import styles from "../root/MainRoot.module.scss";

const MainRoot = () => {
  const { lang } = useParams();
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <LanguageProvider>
      <main className={styles.main_root}>
        <ScrollToTop />
        <Header />
        <Outlet key={pathname} />
        <Footer />
      </main>
    </LanguageProvider>
  );
};

export default MainRoot;
